import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import MessageSuccess from '../../components/form/MessageSuccess';
import YourAsking from './YourAsking';
import Offer from './Offer';
import MyCoordinateFormDetail from '../../components/form/MyCoordinateFormDetail';
import WebEventController from '../../controller/web-event.controller';
import {WebEventUtil} from '../../util/web-event-util';
import {I18n} from '../../util/i18n';
import TitleListScreen from "../../components/TitleListeScreen/TitleListScreen";
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import GieCard from "../../components/GIECard/GieCard";
import HeaderForm from "../../components/form/HeaderForm";
import NoticeForList from "../../components/GIEList/NoticeForList";

export default class ChangeMyOffer extends React.Component<any, any> {
  webEventController: WebEventController = new WebEventController();

  constructor(props: any) {
    super(props);
    this.state = {
      step: 0,
      dataStep1: null,
      dataStep2: null
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  saveDataStep1 = (dataStep1) => {
    this.setState({dataStep1})
    this.next();
  }

  saveDataStep2 = (dataStep2) => {
    this.setState({dataStep2})
    this.next();
  }

  handleSubmit = (form) => {
    const dataStep1 = this.state.dataStep1;
    const i18nFile: any = I18n.getFile();
    const dataStep2 = i18nFile[this.state.dataStep2] != null ? i18nFile[this.state.dataStep2] : this.state.dataStep2;
    let bodyOfMail: any = {};
    Object.keys(form).forEach((name, key) => {
      bodyOfMail[name] = form[name].value
    });
    Object.keys(dataStep1.formControls).forEach((name, key) => {
      bodyOfMail[name] = dataStep1.formControls[name].value
    });
    bodyOfMail.gearChanged = dataStep1.gearChanged;
    bodyOfMail.offerType = dataStep2;
    bodyOfMail.gear = i18nFile[bodyOfMail.gear] != null ? i18nFile[bodyOfMail.gear] : bodyOfMail.gear;

    const request = {
      noContrat: bodyOfMail.noContract,
      eventType: "3",
      eventCode: 'CHGOFFRE',
      description: "Installer ou remplacer un équipement",
      confirm: '0',
      mail_object: WebEventUtil.getBodyOfEmail(bodyOfMail),
      noClient: null,
      codeSite: null
    }
    this.webEventController.insertWebEvent(request).then(data => {
      this.setState({dataSend: true})
      this.next();
    }).catch(err => {
      console.log(err)
    })
  }

  next = () => {
    this.setState({step: this.state.step + 1})
  }

  previous = () => {
    this.setState({step: this.state.step - 1})
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Modifier mon offre"
                                                                      href="changer-mon-offre"
                                                                      title="Transmettez-nous votre demande"/>}>
          <div className="container-xl mb-5">
            <NoticeForList className="mb-3"
                           text="Les offres d’entretien GIE à partir de 115 € TTC"
                           text2="La validation définitive de l’offre et le montant exact interviendra après la visite d’un de nos techniciens sur site."/>

            <GieCard width="100%" height="100%">
              {this.state.step <= 3 && <HeaderForm step={this.state.step}
                                                   first="1 - Votre équipement"
                                                   second="2 - Votre offre"
                                                   third="3 - Vos informations"/>}

              {this.state.step === 0 && <YourAsking next={this.saveDataStep1}/>}
              {this.state.step === 1 && <Offer previous={this.previous} next={this.saveDataStep2}/>}
              {this.state.step === 2 && <MyCoordinateFormDetail confidentiality
                                                                offer
                                                                withButton={false}
                                                                previous={this.previous}
                                                                emit={this.handleSubmit}/>}
              {this.state.step < 3 ? null : (<MessageSuccess/>)}
            </GieCard>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
